import React from "react";
import PropTypes from "prop-types";
import { X } from "lucide-react";
import useModalEvents from "../../hooks/useModalEvents";
import "./ModalWrapper.scss";

const ModalWrapper = ({
  isOpen,
  onClose,
  className = "",
  children,
  center = false,
}) => {
  useModalEvents({ isOpen, onClose });

  return (
    <div
      className={`modal-overlay full-width ${isOpen ? "show" : ""} ${center ? "center" : ""} ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        onClose(e);
      }}
    >
      <div className={`contained-width flex ${center ? "justify-center" : "justify-end"}`}>
        <div
          className="modal-outer relative"
          onClick={(e) => e.stopPropagation()}
        >
          <button className="modal-close-btn" onClick={onClose}>
            <X size={24} />
          </button>
          <div className={`modal-content rounded-20 overflow-hidden `}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

ModalWrapper.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  center: PropTypes.bool
};

export default ModalWrapper;
